import React, { useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { Search, Upload, Plus, Eye, FileText, Share2, Edit3, ChevronLeft, ChevronRight, LayoutGrid, ArrowUpDown, ClipboardCheck } from 'lucide-react';
import { DashboardHeader } from '../components/dashboard/DashboardHeader';
interface Document {
  id: string;
  documentNumber: string;
  name: string;
  createdAt: string;
  status: string;
}
const MOCK_DOCUMENTS: Document[] = [{
  id: '1',
  documentNumber: '3381',
  name: 'EMPLOYEE HANDBOOK (2)',
  createdAt: 'March 17, 2026',
  status: 'Completed'
}, {
  id: '2',
  documentNumber: '3380',
  name: 'EMPLOYEE HANDBOOK (1)',
  createdAt: 'March 17, 2026',
  status: 'Completed'
}, {
  id: '3',
  documentNumber: '3378',
  name: 'EMPLOYEE HANDBOOK',
  createdAt: 'March 17, 2026',
  status: 'Draft'
}, {
  id: '4',
  documentNumber: '3355',
  name: 'By Law Infraction letter',
  createdAt: 'March 13, 2026',
  status: 'Draft'
}, {
  id: '5',
  documentNumber: '3354',
  name: 'Deductible assessment letter',
  createdAt: 'March 13, 2026',
  status: 'Completed'
}, {
  id: '6',
  documentNumber: '3351',
  name: 'WILL (Except Quebec)',
  createdAt: 'March 13, 2026',
  status: 'Draft'
}];
interface DashboardContext {
  toggleMobileSidebar: () => void;
}
interface MyDocumentsProps {
  onMenuClick?: () => void;
  onNavigateToAICopilot?: () => void;
  onNavigate?: (path: string) => void;
}
export function MyDocuments({
  onMenuClick,
  onNavigateToAICopilot,
  onNavigate
}: MyDocumentsProps) {
  const navigate = useNavigate();
  const {
    toggleMobileSidebar
  } = useOutletContext<DashboardContext>() || {
    toggleMobileSidebar: () => {}
  };
  const [searchQuery, setSearchQuery] = useState('');
  const [viewMode, setViewMode] = useState<'list' | 'grid'>('list');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const handleNavigateToAICopilot = () => {
    if (onNavigateToAICopilot) {
      onNavigateToAICopilot();
    } else {
      navigate('/ai-copilot');
    }
  };
  const handleNavigate = (path: string) => {
    if (onNavigate) {
      onNavigate(path);
    } else {
      navigate(path);
    }
  };
  const handleMenuClick = () => {
    if (onMenuClick) {
      onMenuClick();
    } else {
      toggleMobileSidebar();
    }
  };
  return <div className="flex flex-col h-screen bg-white" data-id="element-3712">
      <DashboardHeader categories={['Business', 'HR']} onMenuClick={handleMenuClick} onNavigateToAICopilot={handleNavigateToAICopilot} onNavigate={handleNavigate} data-id="element-3713" />

      <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8" data-id="element-3714">
        <div className="max-w-[1600px] mx-auto space-y-6" data-id="element-3715">
          {/* Top Tabs */}
          <div className="flex items-center justify-end gap-4" data-id="element-3716">
            <button onClick={() => onNavigate && onNavigate('/documents/templates')} className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-secondary hover:bg-gray-50 transition-colors" data-id="element-3717">
              <LayoutGrid className="w-4 h-4" data-id="element-3718" />
              All Templates
            </button>
            <button className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-turquoise border border-turquoise bg-white shadow-sm" data-id="element-3719">
              <FileText className="w-4 h-4" data-id="element-3720" />
              My Documents
            </button>
          </div>

          {/* Action Bar */}
          <div className="bg-white p-4 rounded-xl border border-borderColor flex flex-col lg:flex-row items-center justify-between gap-4" data-id="element-3721">
            <h2 className="text-lg font-bold text-primary" data-id="element-3722">My Documents</h2>

            <div className="flex items-center gap-3 w-full lg:w-auto" data-id="element-3723">
              <div className="relative flex-1 lg:w-80" data-id="element-3724">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-secondary" data-id="element-3725" />
                <input type="text" placeholder="Search by title, categories, type," value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-9 pr-4 py-2 border border-borderColor rounded-lg text-sm focus:outline-none focus:border-turquoise focus:ring-1 focus:ring-turquoise transition-colors" data-id="element-3726" />
              </div>

              <button className="flex items-center gap-2 px-4 py-2 border border-borderColor rounded-lg text-sm font-medium text-primary hover:bg-aliceBlue transition-colors whitespace-nowrap" data-id="element-3727">
                <Upload className="w-4 h-4" data-id="element-3728" />
                Upload Document
              </button>

              <button className="flex items-center gap-2 px-4 py-2 bg-turquoise hover:bg-turquoise/90 text-white rounded-lg text-sm font-medium transition-colors whitespace-nowrap shadow-sm" data-id="element-3729">
                <Plus className="w-4 h-4" data-id="element-3730" />
                CREATE NEW
              </button>
            </div>
          </div>

          {/* Pagination Top */}
          <div className="flex items-center justify-between text-sm text-secondary px-2" data-id="element-3731">
            <span data-id="element-3732">Showing 1-6 of 6</span>
            <div className="flex items-center gap-2" data-id="element-3733">
              <button className="p-1 text-disabled hover:text-secondary disabled:opacity-50" disabled data-id="element-3734">
                <ChevronLeft className="w-4 h-4" data-id="element-3735" />
              </button>
              <button className="w-6 h-6 flex items-center justify-center rounded-full bg-aliceBlue text-primary font-medium" data-id="element-3736">
                1
              </button>
              <button className="p-1 text-disabled hover:text-secondary disabled:opacity-50" disabled data-id="element-3737">
                <ChevronRight className="w-4 h-4" data-id="element-3738" />
              </button>
            </div>
          </div>

          {/* Table */}
          <div className="bg-white border border-borderColor rounded-xl overflow-hidden" data-id="element-3739">
            <div className="overflow-x-auto" data-id="element-3740">
              <table className="w-full text-left text-sm" data-id="element-3741">
                <thead data-id="element-3742">
                  <tr className="border-b border-borderColor text-primary font-semibold" data-id="element-3743">
                    <th className="px-6 py-4 font-semibold" data-id="element-3744">
                      <div className="flex items-center gap-2 cursor-pointer hover:text-violetBlue transition-colors" data-id="element-3745">
                        Document #
                        <ArrowUpDown className="w-3 h-3 text-disabled" data-id="element-3746" />
                      </div>
                    </th>
                    <th className="px-6 py-4 font-semibold" data-id="element-3747">
                      <div className="flex items-center gap-2 cursor-pointer hover:text-violetBlue transition-colors" data-id="element-3748">
                        Document's Name
                        <ArrowUpDown className="w-3 h-3 text-disabled" data-id="element-3749" />
                      </div>
                    </th>
                    <th className="px-6 py-4 font-semibold" data-id="element-3750">
                      <div className="flex items-center gap-2 cursor-pointer hover:text-violetBlue transition-colors" data-id="element-3751">
                        Created At
                        <ArrowUpDown className="w-3 h-3 text-turquoise" data-id="element-3752" />
                      </div>
                    </th>
                    <th className="px-6 py-4 font-semibold text-center" data-id="element-3753">
                      Status
                    </th>
                    <th className="px-6 py-4 font-semibold text-center" data-id="element-3754">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-borderColor" data-id="element-3755">
                  {MOCK_DOCUMENTS.map((doc, index) => <tr key={doc.id} className={`hover:bg-gray-50 transition-colors ${index % 2 === 0 ? 'bg-aliceBlue/50' : 'bg-white'}`} data-id="element-3756">
                      <td className="px-6 py-4 text-primary" data-id="element-3757">
                        {doc.documentNumber}
                      </td>
                      <td className="px-6 py-4 text-primary" data-id="element-3758">{doc.name}</td>
                      <td className="px-6 py-4 text-secondary" data-id="element-3759">
                        {doc.createdAt}
                      </td>
                      <td className="px-6 py-4 text-center" data-id="element-3760">
                        <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${doc.status === 'Completed' ? 'bg-turquoise/10 text-turquoise' : 'bg-gray-100 text-secondary'}`} data-id="element-3761">
                          {doc.status}
                        </span>
                      </td>
                      <td className="px-6 py-4" data-id="element-3762">
                        <div className="flex items-center justify-center gap-3 text-turquoise" data-id="element-3763">
                          <button className="p-1 hover:bg-turquoise/10 rounded transition-colors" title="View" data-id="element-3764">
                            <Eye className="w-4 h-4" data-id="element-3765" />
                          </button>
                          <button className="p-1 hover:bg-turquoise/10 rounded transition-colors" title="Download" data-id="element-3766">
                            <FileText className="w-4 h-4" data-id="element-3767" />
                          </button>
                          <button className="p-1 hover:bg-turquoise/10 rounded transition-colors" title="Share" data-id="element-3768">
                            <Share2 className="w-4 h-4" data-id="element-3769" />
                          </button>
                          <button className="p-1 hover:bg-turquoise/10 rounded transition-colors" title="Edit" data-id="element-3770">
                            <Edit3 className="w-4 h-4" data-id="element-3771" />
                          </button>
                          <button className="p-1 hover:bg-violetBlue/10 rounded transition-colors text-violetBlue" title="Request a Review" data-id="element-3772">
                            <ClipboardCheck className="w-4 h-4" data-id="element-3773" />
                          </button>
                        </div>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </main>
    </div>;
}